<div class="flex justify-end">
  <button
    type="button"
    class="hidden sm:flex items-center justify-center px-5 py-2.5 text-xs font-medium text-white rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 focus:outline-none cursor-pointer"
    (click)="openAddProviderDialog()">
    <mat-icon class="h-4 w-4 mr-2" svgIcon="plus"></mat-icon>
    Add provider
  </button>
</div>
